import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ClientAdminMenuBarList, RoxAdminMenuBarList } from 'constants/constantVariables'
import ClientRouters from 'routes'
import RoxAdminRouters from 'routes/RoxAdminRoutes'
import Notification from 'components/shared/Notification'
import NotificationBell from 'components/NotificationBell/NotificationBell'
import UtilityBar, { UserMenu } from 'components/ds/UtilityBar'
import MenuComponent from './Menu'
import history from 'tools/history'
import Auth from 'tools/AuthService'
import strings from 'strings'
import DemoModeBanner from '../DemoMode/DemoModeBanner'
import { captureLogoutEvent } from '../../posthog/posthogConfig'
import { runningInProdOrDemo } from '../../App'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
  },

  column: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minWidth: 0,
  },

  content: {
    flexGrow: 1,
    minWidth: 0,
    padding: theme.spacing(2),
    position: 'relative',
    backgroundColor: 'var(--bg-canvas)',
  }
}))

const Home = (props) => {
  const classes = useStyles()
  const admin = Auth.hasRole(strings.ROX_ADMIN) // checks whether user has ROX_ADMIN Role
  const [routes] = useState(admin ? <RoxAdminRouters /> : <ClientRouters />)
  const { pathname } = useLocation()
  const user = useSelector(state => state.user.userDetails)

  const [navCollapsed, setNavCollapsed] = useState(false)
  useEffect(() => {
    setNavCollapsed(pathname.includes('applicant'))
  }, [pathname])

  const calculateMenuBarList = () => {
    if (admin){
      return RoxAdminMenuBarList;
    }else{
      return ClientAdminMenuBarList;
    }
  }

  const logOut = () => {
    if (runningInProdOrDemo()) {
      captureLogoutEvent()
    }
    Auth.logout()
    localStorage.clear()
  }

  const fullName = user?.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : strings.PROFILE

  const roleLabel = (Auth.getRoleName() || '')
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/^./, c => c.toUpperCase())

  return (
    <div className={'home-container'}>
      <div className={`${classes.root}`} >
        <MenuComponent
          menuItems={Auth.buildMenubarList(calculateMenuBarList())}
          collapsed={navCollapsed}
          onToggle={() => setNavCollapsed(c => !c)}
          {...props}
        />
        <div className={classes.column}>
          <UtilityBar
            onToggleNav={() => setNavCollapsed(c => !c)}
            navCollapsed={navCollapsed}
          >
            {!Auth.isSalesRep() && <NotificationBell />}
            <UserMenu
              name={fullName}
              role={roleLabel}
              organisation={user?.securityContext?.client?.clientName}
              accountLabel={strings.PROFILE}
              signOutLabel={strings.LOG_OUT}
              onAccount={() => {
                if (history.location.pathname !== '/profile') history.push('/profile')
              }}
              onSignOut={logOut}
            />
          </UtilityBar>
          <main className={classes.content}>
            <DemoModeBanner/>
            {routes}
            <Notification />
          </main>
        </div>
      </div>
    </div>
  )
}

export default Home
